export const taskStatus = {
  STARTED: 'STARTED',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  CANCELED: 'CANCELED',
},
             uploadType = {
               DOCUMENT: 1,
               AUDIO: 2,
               IMAGE: 3,
               TEXT: 4,
               VIDEO: 5,
             },
             mimeTypeMap = {
               'image/jpeg': uploadType.IMAGE,
               'image/gif': uploadType.IMAGE,
               'image/png': uploadType.IMAGE,
               'image/tiff': uploadType.IMAGE,

               'application/vnd.openxmlformats-officedocument.wordprocessingml.document': uploadType.DOCUMENT,
               'application/msword': uploadType.DOCUMENT,
               'application/vnd.oasis.opendocument.presentation': uploadType.DOCUMENT,
               'application/vnd.oasis.opendocument.spreadsheet': uploadType.DOCUMENT,
               'application/vnd.oasis.opendocument.text': uploadType.DOCUMENT,
               'application/pdf': uploadType.DOCUMENT,
               'application/vnd.ms-powerpoint': uploadType.DOCUMENT,
               'application/vnd.openxmlformats-officedocument.presentationml.presentation': uploadType.DOCUMENT,
               'application/vnd.ms-excel': uploadType.DOCUMENT,
               'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': uploadType.DOCUMENT,
               'application/rtf': uploadType.DOCUMENT,
               'application/xml': uploadType.DOCUMENT,
               'application/zip': uploadType.DOCUMENT,
               // added this because it is the mime-type for zip files when using Firefox on Windows
               'application/x-zip-compressed': uploadType.DOCUMENT,
               'application/x-gzip': uploadType.DOCUMENT,
               'application/gzip': uploadType.DOCUMENT,

               'audio/aac': uploadType.AUDIO,
               'audio/mpeg': uploadType.AUDIO,
               'audio/wav': uploadType.AUDIO,

               'text/xml': uploadType.TEXT,
               'text/plain': uploadType.TEXT,
               'text/csv': uploadType.TEXT,

               'video/x-msvideo': uploadType.VIDEO,
               'video/mpeg': uploadType.VIDEO,
               'video/mp4': uploadType.VIDEO,
             },
  // element type constants mapped from the database table list_element_type
             elementTypeMap = {
               TEXT: 'text',
               NUMBER: 'number',
               TEXTAREA: 'textarea',
               RICH_TEXT: 'rich_text',
               CHECKBOX: 'checkbox',
               CHECKBOX_GROUP: 'checkboxgroup',
               RADIO_GROUP: 'radiogroup',
               SELECT: 'select',
               MULTI_SELECT: 'multiselect',
               DATE: 'date',
               TIME: 'time',
               DATETIME: 'datetime',
               DATERANGE: 'dateRange',
               HEADING: 'heading',
               PARAGRAPH: 'p',
             },
             systemSettingTypes = {
               RECORD_NAME: 'name',
               PROGRAM_AREAS: 'program_areas',
               REPORTING_PERIODS: 'reporting_periods',
               ACTION_PLANS: 'action_plans',
               UNIT: 'unit',
               SITE: 'site',
               COMMENTS: 'comments',
               UPLOADS: 'uploads',
             },
             urlPlaceholderID = '/0/',
             imageFileExtensions = ['.jpg', '.jpeg', '.gif', '.png'],
             documentFileExtensions = ['.pdf', '.doc', '.docx', '.xlsx', '.xls', '.ods', '.odt', '.ppt', '.pptx', '.txt', '.html', '.htm'],
             imageMaxSize = (10 * 1024 * 1024), // 10MB
             orderChoices = {
               ASC: 'asc',
               DESC: 'desc',
             },
             organizationLevels = {
               IA: 'ia',
               STATE: 'state',
               REGIONAL: 'regional',
               NATIONAL: 'national',
             },
             filterChoices = { // used to signify a filter, and the corresponding data for filter options in state
               // All Specific to the events page
               ACTION_PLAN: 'action_plan',
               ACTION_PLANS: 'action_plans',
               ACTIVE: 'is_active',
               APPROACHES: 'approaches',
               ATTENDED: 'has_attended',
               CATEGORIES: 'categories',
               CHANGE_TOPIC: 'topic',
               CHANNEL: 'intervention_channels',
               CITIES: 'city',
               CLOSE_IN_END: 'close_date_in_range_1',
               CLOSE_IN_START: 'close_date_in_range_0',
               COLLABORATORS: 'collaborators__user',
               COMPETENCY: 'competency',
               COMPLETED: 'is_complete',
               CONTACTS_DATE_RANGE: 'date_range',
               CONTACT_PREFERENCE: 'contact_preference',
               CONTRIBUTED_BY_COLLABORATOR: 'collaborators__is_contributor',
               COUNTIES: 'unit_county',
               COVID: 'crisis',
               CREATED_BY: 'user',
               CREATED_IN_END: 'created_in_range_1',
               CREATED_IN_START: 'created_in_range_0',
               RELATED_DATA_CREATED_IN_END: 'related_data_created_in_range_1',
               RELATED_DATA_CREATED_IN_START: 'related_data_created_in_range_0',
               CURRENT: 'is_current',
               DELIVERY_TYPE: 'delivery_types',
               EVENT_CATEGORIES: 'event_categories',
               EVENT_ORGANIZERS: 'event_organizers',
               EVENT_SESSION: 'event_sessions',
               EXTENSION_USER: 'in_extension_group',
               FILE_ATTACHMENTS: 'file_type',
               GENDER: 'gender',
               HAS_FEE: 'has_fee',
               HAS_PERSON: 'has_person',
               IMPORTED_BY: 'import_uploads',
               INDICATORS: 'priority_indicators',
               INITIALIZED: 'is_initialized',
               INTERVENTION_NAME: 'intervention',
               PARENT_REGISTRATION_EMAIL: 'parent_registration_email',
               IS_ORGANIZATION: 'is_organization',
               IS_SNAC: 'is_snac',
               IS_TEMPLATE: 'is_template', // for Form model
               IS_VIRTUAL: 'is_virtual',
               KEYWORDS: 'keywords',
               LEVEL: 'level',
               MAX_RANGE: 'max_range',
               NOTEWORTHY: 'is_noteworthy',
               OCCURRENCE_DATE_RANGE_END: 'occurrence_date_1',
               OCCURRENCE_DATE_RANGE_START: 'occurrence_date_0',
               OPEN_IN_END: 'open_date_in_range_1',
               OPEN_IN_START: 'open_date_in_range_0',
               ORGANIZATION: 'organization',
               PAYMENT_STATUS: 'payment_status',
               PLAN_TYPE: 'type',
               POSITIONS: 'positions',
               PRIMARY_CURRICULUM: 'primary_curriculum',
               PROGRAM_AREAS: 'program_areas',
               PROGRAM_AREA_GROUPS: 'main_program_area',
               PROJECT_NAME: 'project',
               PUBLISHED: 'is_published',
               QUARTER: 'quarter',
               REGISTRATION_TYPE: 'registration_type',
               REPORTING_PERIOD_TYPE: 'program_type',
               REPORTING_PERIOD_YEAR: 'year',
               REVIEW_USER: 'review_user',
               SEARCH: 'q',
               SETTING: 'setting',
               SHOW_PAST_EVENTS: 'show_upcoming_events',
               SITES: 'site',
               SITE_USAGE: 'site_usage',
               SNAPED_USER: 'in_snaped_group',
               SOCIO_FRAMEWORK: 'socioecological_framework',
               STARTED_IN_END: 'started_in_range_1',
               STARTED_IN_START: 'started_in_range_0',
               STATUS: 'status',
               STATUS_VERBOSE: 'status_verbose',
               SUPERVISOR: 'review_user__supervisor_user',
               TOPIC: 'intervention_topics',
               UNITS: 'unit',
               RELATED_DATA_UNITS: 'related_data_units',
               SITE_UNITS: 'site_unit',
               USER_GROUP: 'user_groups',
               VERIFIED: 'is_verified',
               YEAR: 'year',
               ZIP: 'site__zip_code__name',
               ZIP_CODE: 'zip_code',
             },
             filterData = {
               // for data that is not a filter in and of itself but used by filters
               // Could possibly run into issues here if we have an Ajax and a static filter that use the same key on the same page
               REPORTING_PERIODS: 'reporting_periods',
               USERS: 'user_list',
             },
             filterNameToOptionKey = {
               // Use filterNameToOptionKey when there are filters that you want to display options for when the option name doesn't match the filter name.
               [filterChoices.STATUS_VERBOSE]: filterChoices.STATUS,
             },
             defaultFilters = [
               [filterChoices.REPORTING_PERIOD_YEAR, filterChoices.REPORTING_PERIOD_TYPE],
               filterChoices.PROGRAM_AREAS,
               filterChoices.CREATED_BY,
               [filterChoices.COLLABORATORS, filterChoices.CONTRIBUTED_BY_COLLABORATOR],
             ],
             filterConfigSet = {
               /**
     * This defines which filters to use on a given list view.
     */
               default: defaultFilters,
               program_activities: [
                 ...defaultFilters,
                 filterChoices.SITES,
                 filterChoices.ZIP,
                 filterChoices.PRIMARY_CURRICULUM,
                 filterChoices.UNITS,
                 filterChoices.PROJECT_NAME,
                 filterChoices.INTERVENTION_NAME,
                 filterChoices.ACTION_PLANS,
                 filterChoices.INDICATORS,
                 filterChoices.FILE_ATTACHMENTS,
                 [filterChoices.OCCURRENCE_DATE_RANGE_START, filterChoices.OCCURRENCE_DATE_RANGE_END],
                 filterChoices.COVID,
                 filterChoices.IMPORTED_BY,
                 filterChoices.COMPLETED,
                 filterChoices.VERIFIED,
               ],
               surveys: [
                 filterChoices.PROGRAM_AREAS,
                 filterChoices.CREATED_BY,
                 filterChoices.DELIVERY_TYPE,
                 filterChoices.STATUS,
                 [filterChoices.CREATED_IN_START, filterChoices.CREATED_IN_END],
               ],
               pse: [
                 ...defaultFilters,
                 filterChoices.UNITS,
                 filterChoices.PROJECT_NAME,
                 filterChoices.INTERVENTION_NAME,
                 filterChoices.ACTION_PLAN,
                 filterChoices.SETTING,
                 filterChoices.SITES,
                 filterChoices.ZIP,
                 filterChoices.FILE_ATTACHMENTS,
                 [filterChoices.CREATED_IN_START, filterChoices.CREATED_IN_END],
                 filterChoices.COVID,
                 filterChoices.COMPLETED,
                 filterChoices.VERIFIED,
               ],
               changes_adopted: [
                 filterChoices.CHANGE_TOPIC,
               ],
               action_plans: [
                 ...defaultFilters,
                 filterChoices.PLAN_TYPE,
                 filterChoices.UNITS,
                 filterChoices.LEVEL,
                 filterChoices.COVID,
                 filterChoices.STATUS_VERBOSE,
                 filterChoices.COMPLETED,
               ],
               action_plan_outcomes: [
                 ...defaultFilters,
                 filterChoices.PLAN_TYPE,
                 filterChoices.LEVEL,
                 [filterChoices.CREATED_IN_START, filterChoices.CREATED_IN_END],
                 filterChoices.UNITS,
                 filterChoices.ACTION_PLAN,
                 filterChoices.COMPLETED,
                 filterChoices.VERIFIED,
               ],
               indirect_activities: [
                 ...defaultFilters,
                 filterChoices.UNITS,
                 filterChoices.PROJECT_NAME,
                 filterChoices.INTERVENTION_NAME,
                 filterChoices.ACTION_PLAN,
                 filterChoices.COVID,
                 filterChoices.FILE_ATTACHMENTS,
                 [filterChoices.CREATED_IN_START, filterChoices.CREATED_IN_END],
                 filterChoices.COMPLETED,
                 filterChoices.VERIFIED,
               ],
               partnerships: [
                 ...defaultFilters,
                 filterChoices.UNITS,
                 filterChoices.SITES,
                 filterChoices.ZIP,
                 filterChoices.ACTION_PLAN,
                 filterChoices.FILE_ATTACHMENTS,
                 [filterChoices.CREATED_IN_START, filterChoices.CREATED_IN_END],
                 filterChoices.COVID,
                 filterChoices.COMPLETED,
                 filterChoices.VERIFIED,
               ],
               coalitions: [
                 ...defaultFilters,
                 // missing id
                 filterChoices.UNITS,
                 filterChoices.IS_SNAC,
                 filterChoices.ACTION_PLAN,
                 filterChoices.FILE_ATTACHMENTS,
                 [filterChoices.CREATED_IN_START, filterChoices.CREATED_IN_END],
                 filterChoices.COVID,
                 filterChoices.COMPLETED,
                 filterChoices.VERIFIED,
               ],
               social_marketing: [
                 ...defaultFilters,
                 filterChoices.UNITS,
                 filterChoices.PROJECT_NAME,
                 filterChoices.INTERVENTION_NAME,
                 filterChoices.ACTION_PLAN,
                 filterChoices.TOPIC,
                 filterChoices.CHANNEL,
                 [filterChoices.CREATED_IN_START, filterChoices.CREATED_IN_END],
                 filterChoices.COVID,
                 filterChoices.COMPLETED,
                 filterChoices.VERIFIED,
               ],
               quarterly_efforts: [
                 [filterChoices.REPORTING_PERIOD_YEAR, filterChoices.REPORTING_PERIOD_TYPE],
                 filterChoices.PROGRAM_AREAS,
                 filterChoices.CREATED_BY,
                 filterChoices.QUARTER,
                 filterChoices.UNITS,
                 [filterChoices.CREATED_IN_START, filterChoices.CREATED_IN_END],
                 filterChoices.COMPLETED,
               ],
               direct_contacts: [
                 [filterChoices.REPORTING_PERIOD_YEAR, filterChoices.REPORTING_PERIOD_TYPE],
                 filterChoices.PROGRAM_AREAS,
                 filterChoices.CREATED_BY,
                 filterChoices.UNITS,
                 filterChoices.CONTACTS_DATE_RANGE,
               ],
               success_stories: [
                 ...defaultFilters,
                 // make search work on id
                 filterChoices.UNITS,
                 filterChoices.SITES,
                 filterChoices.NOTEWORTHY,
                 filterChoices.INDICATORS,
                 filterChoices.KEYWORDS,
                 filterChoices.SOCIO_FRAMEWORK,
                 filterChoices.APPROACHES,
                 filterChoices.ACTION_PLAN,
                 filterChoices.FILE_ATTACHMENTS,
                 [filterChoices.CREATED_IN_START, filterChoices.CREATED_IN_END],
                 filterChoices.COVID,
                 filterChoices.COMPLETED,
                 filterChoices.VERIFIED,
               ],
               review_plans: [
                 filterChoices.REPORTING_PERIOD_YEAR,
                 filterChoices.POSITIONS,
               ],
               user_reviews: [filterChoices.REPORTING_PERIOD_YEAR],
               supervisor_reviews: [
                 filterChoices.REPORTING_PERIOD_YEAR,
                 filterChoices.SUPERVISOR,
                 filterChoices.REVIEW_USER,
                 filterChoices.POSITIONS,
                 filterChoices.COMPLETED,
               ],
               crm: [
                 filterChoices.ACTIVE,
                 filterChoices.UNITS,
                 filterChoices.CATEGORIES,
                 filterChoices.YEAR,
               ],
               key_users: [
                 filterChoices.ORGANIZATION,
                 filterChoices.USER_GROUP,
               ],
               board_members: [
                 filterChoices.CURRENT,
                 filterChoices.CONTACT_PREFERENCE,
                 filterChoices.UNITS,
               ],
               directors: [
                 filterChoices.CURRENT,
                 filterChoices.UNITS,
               ],
               reporting_periods: [
                 filterChoices.REPORTING_PERIOD_YEAR,
                 filterChoices.REPORTING_PERIOD_TYPE,
                 filterChoices.INITIALIZED,
                 filterChoices.PROGRAM_AREAS,
                 [filterChoices.OPEN_IN_START, filterChoices.OPEN_IN_END],
                 [filterChoices.CLOSE_IN_START, filterChoices.CLOSE_IN_END],
               ],
               sites: [
                 filterChoices.CREATED_BY,
                 filterChoices.CITIES,
                 filterChoices.ZIP_CODE,
                 filterChoices.IS_ORGANIZATION,
                 filterChoices.SITE_USAGE,
                 filterChoices.RELATED_DATA_UNITS,
                 [filterChoices.RELATED_DATA_CREATED_IN_START, filterChoices.RELATED_DATA_CREATED_IN_END],
               ],
               development_plans: [
                 [filterChoices.REPORTING_PERIOD_YEAR, filterChoices.REPORTING_PERIOD_TYPE],
                 filterChoices.CREATED_BY,
               ],
               events: [[filterChoices.REPORTING_PERIOD_YEAR, filterChoices.REPORTING_PERIOD_TYPE]],
               event_catalog: [
                 [filterChoices.REPORTING_PERIOD_YEAR, filterChoices.REPORTING_PERIOD_TYPE],
                 filterChoices.PROGRAM_AREAS,
                 filterChoices.COMPETENCY,
                 filterChoices.LEVEL,
                 filterChoices.SHOW_PAST_EVENTS,
               ],
               proposed_events: [
                 [filterChoices.REPORTING_PERIOD_YEAR, filterChoices.REPORTING_PERIOD_TYPE],
                 filterChoices.CREATED_BY,
                 filterChoices.STATUS_VERBOSE,
               ],
               users: [
                 filterChoices.PROGRAM_AREAS,
                 filterChoices.ACTIVE,
                 filterChoices.SNAPED_USER,
                 filterChoices.EXTENSION_USER,
                 filterChoices.UNITS,
                 filterChoices.USER_GROUP,
               ],
               snaped_custom_data_template: [
                 filterChoices.REPORTING_PERIOD_YEAR,
               ],
               dashboards_extension: [
                 [filterChoices.REPORTING_PERIOD_YEAR, filterChoices.REPORTING_PERIOD_TYPE],
                 filterChoices.PROGRAM_AREAS,
                 filterChoices.CREATED_BY,
                 [filterChoices.COLLABORATORS, filterChoices.CONTRIBUTED_BY_COLLABORATOR],
                 filterChoices.UNITS,
                 filterChoices.SITES,
                 filterChoices.ACTION_PLAN,
                 filterChoices.SETTING,
                 filterChoices.COMPLETED,
               ],
               dashboards_snaped: [
                 filterChoices.REPORTING_PERIOD_YEAR,
                 filterChoices.PROGRAM_AREAS,
                 filterChoices.CREATED_BY,
                 [filterChoices.COLLABORATORS, filterChoices.CONTRIBUTED_BY_COLLABORATOR],
                 filterChoices.SITES,
                 filterChoices.PRIMARY_CURRICULUM,
                 filterChoices.UNITS,
                 filterChoices.INTERVENTION_NAME,
                 filterChoices.PROJECT_NAME,
                 filterChoices.COMPLETED,
               ],
               dashboards_census: [
                 filterChoices.REPORTING_PERIOD_YEAR,
                 filterChoices.PROGRAM_AREAS,
                 filterChoices.CREATED_BY,
                 [filterChoices.COLLABORATORS, filterChoices.CONTRIBUTED_BY_COLLABORATOR],
                 filterChoices.SITES,
                 filterChoices.PRIMARY_CURRICULUM,
                 filterChoices.UNITS,
                 filterChoices.INTERVENTION_NAME,
                 filterChoices.COMPLETED,
               ],
               dashboards_unit_snapshot: [
                 [[filterChoices.REPORTING_PERIOD_YEAR, filterChoices.REPORTING_PERIOD_TYPE]],
                 [filterChoices.CREATED_IN_START, filterChoices.CREATED_IN_END],
                 filterChoices.PROGRAM_AREAS,
                 filterChoices.UNITS,
                 filterChoices.COMPLETED,
                 [filterChoices.OCCURRENCE_DATE_RANGE_START, filterChoices.OCCURRENCE_DATE_RANGE_END],
               ],
               dashboards_user: [
                 filterChoices.REPORTING_PERIOD_YEAR,
                 filterChoices.PROGRAM_AREAS,
                 filterChoices.CREATED_BY,
                 [filterChoices.COLLABORATORS, filterChoices.CONTRIBUTED_BY_COLLABORATOR],
                 filterChoices.ACTION_PLAN,
                 filterChoices.COMPLETED,
               ],
               dashboards_test: [
                 filterChoices.REPORTING_PERIOD_YEAR,
                 filterChoices.PROGRAM_AREAS,
                 filterChoices.CREATED_BY,
                 [filterChoices.COLLABORATORS, filterChoices.CONTRIBUTED_BY_COLLABORATOR],
                 filterChoices.SITES,
                 filterChoices.PRIMARY_CURRICULUM,
                 filterChoices.UNITS,
                 filterChoices.INTERVENTION_NAME,
                 filterChoices.COMPLETED,
               ],
               dashboards_program_and_participants: [
                 filterChoices.REPORTING_PERIOD_YEAR,
                 filterChoices.CREATED_BY,
                 [filterChoices.COLLABORATORS, filterChoices.CONTRIBUTED_BY_COLLABORATOR],
                 filterChoices.SITES,
                 filterChoices.UNITS,
                 [filterChoices.OCCURRENCE_DATE_RANGE_START, filterChoices.OCCURRENCE_DATE_RANGE_END],
                 filterChoices.COMPLETED,
               ],
               dashboards_contacts_by_critical_issue: [
                 [filterChoices.REPORTING_PERIOD_YEAR, filterChoices.REPORTING_PERIOD_TYPE],
                 filterChoices.PROGRAM_AREAS,
                 filterChoices.CREATED_BY,
                 filterChoices.QUARTER,
                 filterChoices.UNITS,
                 [filterChoices.CREATED_IN_START, filterChoices.CREATED_IN_END],
                 filterChoices.COMPLETED,
               ],
               dashboards_duplicate_contacts: [
                 ...defaultFilters,
                 filterChoices.SITES,
                 filterChoices.PRIMARY_CURRICULUM,
                 filterChoices.UNITS,
                 filterChoices.PROJECT_NAME,
                 filterChoices.INTERVENTION_NAME,
                 filterChoices.ACTION_PLANS,
                 filterChoices.INDICATORS,
                 filterChoices.FILE_ATTACHMENTS,
                 [filterChoices.OCCURRENCE_DATE_RANGE_START, filterChoices.OCCURRENCE_DATE_RANGE_END],
                 filterChoices.VERIFIED,
                 filterChoices.COMPLETED,
               ],
               manage_registrations: [
                 filterChoices.ATTENDED,
                 filterChoices.PAYMENT_STATUS,
                 filterChoices.PARENT_REGISTRATION_EMAIL,
                 filterChoices.REGISTRATION_TYPE,
                 filterChoices.EVENT_SESSION,
                 filterChoices.COMPLETED,
                 filterChoices.HAS_PERSON,
               ],
               manage_events: [
                 [filterChoices.STARTED_IN_START, filterChoices.STARTED_IN_END],
                 filterChoices.PUBLISHED,
                 filterChoices.HAS_FEE,
                 filterChoices.CREATED_BY,
                 filterChoices.SITES,
                 filterChoices.EVENT_CATEGORIES,
                 filterChoices.EVENT_ORGANIZERS,
               ],
               manage_event_templates: [
                 filterChoices.IS_TEMPLATE,
               ],
               public_events: [
                 filterChoices.COUNTIES,
                 filterChoices.ZIP_CODE,
                 filterChoices.HAS_FEE,
                 [filterChoices.CITIES, filterChoices.MAX_RANGE],
                 filterChoices.IS_VIRTUAL,
                 filterChoices.EVENT_CATEGORIES,
                 filterChoices.EVENT_ORGANIZERS,
               ],
               module_viewer: [
                 filterChoices.YEAR,
                 filterChoices.CREATED_BY,
                 filterChoices.PROGRAM_AREAS,
                 filterChoices.ACTION_PLANS,
                 filterChoices.SITES,
                 filterChoices.UNITS,
                 filterChoices.COMPLETED,
               ],
               no_filters: [],
             },
             queryParams = {
               PAGE: 'page',
               PAGE_SIZE: 'page_size',
               ORDERING: 'ordering',
             },
             queryValues = {
               LIST_FILTER_LENGTH: 20,
             },
             communicationMethod = {
               IN_PERSON: 'in_person',
               PHONE: 'phone',
               EMAIL: 'email',
               VIDEO_CONFERENCE: 'video_conference',
               SOCIAL_MEDIA: 'social_media',
               TEXT: 'text',
               INTERNAL_NOTE: 'internal_note',
               ROSTER_ATTENDANCE: 'roster_attendance',
               EVENT: 'event',
               OTHER: 'other',
             },
             manyToManyFields = [
               'program_areas',
               'reporting_periods',
             ],
             bulkActionState = {
               EDIT: 'edit',
               COPY: 'copy',
               PROGRESS: 'progress',
               ERRORS: 'errors',
               COMPLETE: 'complete',
             };
